import { messages as ptMessages } from "./pt";

// Fallback para português - traduções em inglês podem ser adicionadas posteriormente
const messages = {
  en: {
    translations: ptMessages.pt.translations
  }
};

export { messages };
